import React, { Component } from 'react';
import moment from 'moment';
import theme from 'react-dates/lib/theme/DefaultTheme.js';
import 'react-dates/initialize';
import {
    HORIZONTAL_ORIENTATION,
    VERTICAL_ORIENTATION,
    VERTICAL_SCROLLABLE,
} from 'react-dates/lib/constants';

// Modified Component
import {
    PureDateRangePicker,
    default as withStylesRangePicker
} from './DateRangePicker';


class RangePicker extends Component {

    static defaultProps = {
        startDate: null,
        endDate: null,
        focusedInput: null,
        startDateId: 'startDate',
        endDateId: 'endDate',
        displayFormat: 'ddd MM/DD',
        startDateLabelText: 'CHECK-IN',
        endDateLabelText: 'CHECK-OUT',
        minimumNights: 3,
    };

    // static getDerivedStateFromProps(nextProps) {

    //     const { startDate, endDate, focusedInput } = nextProps;

    //     return ({ startDate, endDate, focusedInput });
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // Store prevId in state so we can compare when props change.
        // Clear out previously-loaded data (so we don't render stale stuff).
        if (nextProps.startDate !== prevState.startDate) {
            return {
                externalData: null,
                prevId: nextProps.id
            };
        }

        // No state update necessary
        return null;
    }

    constructor(props) {

        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            focusedInput: null,
        };

        this.currentDate = moment();
        this.minDate = moment(this.currentDate, 'MM-DD').add(2, 'days');
        this.maxDate = moment('01-01', 'MM-DD').add(3, 'years');

        this.initialVisibleMonth = () => this.minDate;

        this._onDatesChange = this._onDatesChange.bind(this);
    }

    _onDatesChange({startDate, endDate}) {

        const datesCloned = Object.assign({}, { startDate, endDate });

        this.props.onDatesChange(datesCloned);

        this.setState({ startDate, endDate });
    }

    _isOutsideRange() {

        // const maximumNights = 21;

        return (( day ) => {

            let addMaximumDate = false;
            let addMinimumDate = false;

            // Applies for START/END day.
            addMinimumDate = day.isBefore(this.minDate);
            addMaximumDate = day.isAfter(this.maxDate);

            return addMaximumDate || addMinimumDate;

        });

    }

    renderCalendarInfo() {
        return () => {
            return (
                <div className="calendar-info">
                    <span className="dot">{'\u00b7'}</span>Minimum Stay: {this.props.minimumNights} nights
                </div>
            );
        };
    }

    render() {

        const { startDate, endDate } = this.state;
        const deviceWidth = window.innerWidth;
        // const orientation = deviceWidth < 992 ? VERTICAL_SCROLLABLE : HORIZONTAL_ORIENTATION;
        const orientation = HORIZONTAL_ORIENTATION;

        return (
            <div className="date-range-picker">
                <PureDateRangePicker
                    startDateId={this.props.startDateId}
                    endDateId={this.props.endDateId}
                    startDate={startDate}
                    endDate={endDate}
                    focusedInput={this.props.focusedInput}
                    onFocusChange={this.props.onFocusChange}
                    onDatesChange={this._onDatesChange}
                    isOutsideRange={this._isOutsideRange()}
                    startDatePlaceholderText={this.props.startDatePlaceholderText}
                    endDatePlaceholderText={this.props.endDatePlaceholderText}
                    theme={theme}
                    styles={{}}
                    css={withStylesRangePicker}
                    renderCalendarInfo={this.renderCalendarInfo()}

                    // Custom Props
                    startDateLabelText={this.props.startDateLabelText}
                    endDateLabelText={this.props.endDateLabelText}
                    noLabels={this.props.noLabels}

                    // calendar presentation and interaction related props
                    anchorDirection={this.props.anchorDirection}
                    horizontalMargin={0}
                    withPortal={false}
                    initialVisibleMonth={ this.initialVisibleMonth }


                    withFullScreenPortal={false}
                    orientation={ this.props.orientation || orientation }
                    numberOfMonths={ this.props.numberOfMonths }
                    // numberOfMonths={ window.innerWidth < 768 ? 1 : 2 }
                    // customCloseIcon={<div className="DateRangePicker_closeButton">Done</div>}
                    // keepOpenOnDateSelect={ deviceWidth  < 768 }
                    // showClearDate

                    // day presentation and interaction related props
                    enableOutsideDays={false}
                    isDayBlocked={ () => false }
                    isDayHighlighted={ () => {}}

                    // internationalization props
                    displayFormat={this.props.displayFormat}
                    minimumNights={this.props.minimumNights}
                    hideKeyboardShortcutsPanel
                    readOnly
                />
            </div>
        );
    }
}

export default RangePicker;
